import { BuyerVatInfo, buyerVatInfo } from "@/framework/billing/buyerVatInfo";
import { BuyerType, suggestedTopupAmounts } from "@/framework/billing/stripe";
import { BuyerSelection } from "@/modules/billing/buyer/BuyerTypeCountryFields";
import { isCountryAllowedForBuyerType } from "@/modules/billing/buyer/buyerCountryOptions";
import { action, computed, makeAutoObservable, observable } from "mobx";

// Selection state for the standalone picker on the pricing page. The account
// topup page has its own selection state, since it also drives checkout.
export class CreditAmountPickerState {
  selectedAmount: number;
  buyerType: BuyerType = "private";
  // Empty until the visitor picks a country, which leaves the VAT unknown.
  countryCode = "";

  constructor(selectedAmount: number = suggestedTopupAmounts[0]) {
    this.selectedAmount = selectedAmount;
    makeAutoObservable(this, {
      selectedAmount: observable,
      buyerType: observable,
      countryCode: observable,
      setSelectedAmount: action,
      setBuyerSelection: action,
      isCountrySupported: computed,
      vatInfo: computed,
    });
  }

  get isCountrySupported(): boolean {
    return (
      this.countryCode === "" ||
      isCountryAllowedForBuyerType(this.buyerType, this.countryCode)
    );
  }

  // VAT is only meaningful for combinations we can actually sell to.
  get vatInfo(): BuyerVatInfo | undefined {
    return this.isCountrySupported
      ? buyerVatInfo(this.buyerType, this.countryCode)
      : undefined;
  }

  setSelectedAmount(amount: number) {
    this.selectedAmount = amount;
  }

  setBuyerSelection(selection: BuyerSelection) {
    this.buyerType = selection.buyerType;
    this.countryCode = selection.countryCode;
  }
}
